interface SEOProps {
  title?: string;
  description?: string;
  ogImage?: string;
  ogUrl?: string;
  ogType?: 'website' | 'profile';
  twitterCard?: 'summary' | 'summary_large_image';
  children?: React.ReactNode;
}

const DEFAULT_TITLE = 'EveningHoney.AI Girlfriends & Companions | Chat, videos, calls'; 
const DEFAULT_SOCIAL_TITLE = 'EveningHoney.AI Companions | Chat, videos, calls';
const DEFAULT_DESCRIPTION = 'Chat with realistic AI companions, generate images and videos. Enjoy phone calls, immersive roleplay and relationships with AI girlfriends and boyfriends.';
const DEFAULT_SOCIAL_DESCRIPTION = 'Chat with AI companions, generate images and videos, enjoy immersive roleplay and connections. Experience the future of AI relationships.';

export const SEO = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  ogImage = '/images/eh-og-image.png',
  ogUrl,
  ogType = 'website',
  twitterCard = 'summary_large_image',
  children,
}: SEOProps) => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://eveninghoney.ai';
  const fullTitle = title.includes('EveningHoney.AI') ? title : `${title} | EveningHoney.AI`;
  const fullOgUrl = ogUrl ? `${siteUrl}${ogUrl}` : siteUrl;
  const fullOgImage = ogImage.startsWith('http') ? ogImage : `${siteUrl}${ogImage}`;

  const socialTitle = title === DEFAULT_TITLE ? DEFAULT_SOCIAL_TITLE : fullTitle;
  const socialDescription = description === DEFAULT_DESCRIPTION ? DEFAULT_SOCIAL_DESCRIPTION : description;

  return (
    <>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullOgUrl} />
      <meta property="og:title" content={socialTitle} />
      <meta property="og:description" content={socialDescription} />
      <meta property="og:image" content={fullOgImage} />

      {/* Twitter */}
      <meta property="twitter:card" content={twitterCard} />
      <meta property="twitter:url" content={fullOgUrl} />
      <meta property="twitter:title" content={socialTitle} />
      <meta property="twitter:description" content={socialDescription} />
      <meta property="twitter:image" content={fullOgImage} />

      {children}
    </>
  );
}; 